import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore'; // <- needed if using firestore
import 'firebase/performance'; // <- needed if using firestore
import 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyCOuRrRMUyNaArw0BZI9kyeLdntRn8RdW0',
  authDomain: 'vitalyuncensored-a5339.firebaseapp.com',
  databaseURL: 'https://vitalyuncensored-a5339.firebaseio.com',
  projectId: 'vitalyuncensored-a5339',
  storageBucket: 'vitalyuncensored-a5339.appspot.com',
  messagingSenderId: '81936997385',
  appId: '1:81936997385:web:d6c6d79172e5e755'
};

firebase.initializeApp(firebaseConfig);
firebase.firestore(); // <- needed if using firestore
firebase.performance();

export default firebase;
